import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const MastermindLink = ({ geneSymbol }) => {
  return (
    <a
      href={getVarsoUrl(
        `https://mastermind.genomenon.com/detail?gene=${geneSymbol?.toLowerCase()}&disease=all%20diseases&category=overall&ref=varsome`
      )}
      target="_blank"
      className="varsome-gene-link"
    >
      Mastermind
    </a>
  );
};

MastermindLink.propTypes = {
  geneSymbol: PropTypes.string,
};

MastermindLink.defaultProps = {
  geneSymbol: null,
};

export default MastermindLink;
